import React from 'react';
import translate, { TranslationKey } from '../functions/translate';

interface TranslatedSpanProps {
    english: TranslationKey
    id?: string
    replacements?: {}
    style?: React.CSSProperties
    className?: string
}

const TranslatedSpan = (props: TranslatedSpanProps) => <span id={props.id} style={props.style}>{translate(props.english, props.replacements)}</span>;

export default TranslatedSpan;
